import React from 'react';

import { Job } from '@utils/aboutInterfaces';
import { BENEFITS } from '@utils/constants';
import { getImgixSrc } from '@utils/images';

import OpenPositions from './OpenPositions';

interface CareersProps {
  careersRef: React.RefObject<HTMLDivElement>;
  jobs: Job[];
}

const Careers = ({ careersRef, jobs }: CareersProps) => {
  return (
    <section
      id="careers"
      ref={careersRef}
      className="mx-auto max-w-[1040px] border-0 border-y border-solid border-grayscale-beige py-32 sm:py-48"
    >
      <h2 className="mb-24 text-center font-suisse-works text-headline-md">Careers</h2>
      <div className="text-center font-suisse-neue text-body-lg">
        The Information is seeking individuals passionate about the future of the news business for
        the roles below.
      </div>
      <div className="my-48 grid grid-cols-2 gap-48 sm:grid-cols-3 lg:grid-cols-4">
        {BENEFITS.map((benefit) => (
          <div key={benefit.label} className="flex flex-col items-center gap-16">
            <img
              src={getImgixSrc({ path: benefit.icon, isEnvDependent: false })}
              alt={benefit.label}
              className="h-[70px] w-[70px]"
            />
            <div className="font-suisse-intl text-body-sm font-bold">{benefit.label}</div>
          </div>
        ))}
      </div>
      {jobs.length > 0 && <OpenPositions jobs={jobs} />}
    </section>
  );
};

export default Careers;
